import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18next';

import { Table, TableBody, TableCell, TableHead, TableRow } from 'uikit/tables';

import styles from '../styles/bulkImportModalTable.module.scss';

const BulkImportModalTable = ({ data = [], isTemplate = true }) => {
  const head = isTemplate
    ? [i18n.t('csv-column'), i18n.t('column-name'), i18n.t('description'), i18n.t('value-type')]
    : data[0];

  const body = isTemplate
    ? data.map((row) => [row.csv_map, row.label_name, row.description, row.type])
    : data.slice(1);

  return (
    <Table>
      <TableHead>
        <TableRow>
          {head.map((cell) => (
            <TableCell key={cell}>{cell}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {body.map((row) => {
          const key = row[0];

          return (
            <TableRow className={styles.row} key={key}>
              {row.map((cell, index) => (
                <TableCell key={`${head[index]}-${key}`}>{cell}</TableCell>
              ))}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

BulkImportModalTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.shape({
        csv_map: PropTypes.string,
        description: PropTypes.string,
        label_name: PropTypes.string,
        type: PropTypes.string,
      }),
    ]),
  ),
  isTemplate: PropTypes.bool,
};

export default React.memo(BulkImportModalTable);
